module.exports = __webpack_public_path__ + "static/img/product.a9d252c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner/product.png
// module id = EXed
// module chunks = 12